import React from 'react';
import '../CSS/SoftwareEngineering.css';

const SoftwareEngineering: React.FC = () => {
  return (
    <div className="software-engineering-page">
      <div className="software_hero">
        <div className="banner-overlay"></div>
        <div className="banner-content">
          <h1 className="banner-title">Software Engineering</h1>
        </div>
      </div>

      <div className="software_facts">
        <div className="software-content">
          <div className="software-description">
            <p>Zemantics has experienced developers dedicated to helping businesses and organizations stay ahead of the curve by building purpose-specific and innovative custom software and applications.</p>
          </div>
          
          <div className="software_cards">
            <div className="software-card-item">
              <div className="card-icon">
                <img src="/Assets/Services/Software Engineering/software-dev-services-icon.svg" alt="Custom Software Development Services" />
              </div>
              <h3 className="card-title">Empowering Your Business Innovation With Our Custom Software Development Services</h3>
              <p className="card-description">With 15+ years of experience, we have developed over 175+ software products, proving our expertise in the design and development of tech products. Our custom software applications meet your specific use case, budget, and timeline.</p>
            </div>

            <div className="software-card-item">
              <div className="card-icon">
                <img src="/Assets/Services/Software Engineering/application-services-icon.svg" alt="Application Services" />
              </div>
              <h3 className="card-title">Application Services</h3>
              <p className="card-description">Our experts handle every aspect of app development, including design, testing, deployment, management, and maintenance for all apps, such as mobile, web, and desktop.</p>
            </div>

            <div className="software-card-item">
              <div className="card-icon">
                <img src="/Assets/Services/Software Engineering/custom-software-development-icon.svg" alt="Custom Software Development" />
              </div>
              <h3 className="card-title">Custom Software Development</h3>
              <p className="card-description">We combine the core functionality of the business process in focus and enhance the software with custom software capabilities and features for your specific requirements.</p>
            </div>

            <div className="software-card-item">
              <div className="card-icon">
                <img src="/Assets/Services/Software Engineering/testing-icon.svg" alt="Testing & QA" />
              </div>
              <h3 className="card-title">Testing & QA</h3>
              <p className="card-description">Leverage our QA team's expertise in implementing the best software testing methodologies, such as performance, automated and functional testing, to boost your software's security, usability, and quality.</p>
            </div>

            <div className="software-card-item">
              <div className="card-icon">
                <img src="/Assets/Services/Software Engineering/design-dev-icon.svg" alt="UI/UX Design" />
              </div>
              <h3 className="card-title">UI/UX Design</h3>
              <p className="card-description">By combining the latest trends in UI/UX with our client's preferences and requirements, we deliver vivid and intuitive designs for all applications and software.</p>
            </div>

            <div className="software-card-item">
              <div className="card-icon">
                <img src="/Assets/Services/Software Engineering/agile-development-icon.svg" alt="Agile Development" />
              </div>
              <h3 className="card-title">Agile Development</h3>
              <p className="card-description">Our Agile approach allows us to develop high-quality software that meets stakeholders' changing needs cost-effectively and faster than ever before. We also help clients build Agile capabilities and implement Agile concepts and methodologies.</p>
            </div>
                     </div>
         </div>
       </div>

       <div className="software_tech_stack desktop-software-tech-stack">
         <div className="tech-stack-icon">
           <img src="/Assets/Services/Software Engineering/technology-stack-icon.svg" alt="Technology Stack Icon" />
         </div>
         <div className="tech-stack-title">
           <h2>Technology Stack</h2>
         </div>
         <div className="tech-stack-image">
           <img src="/Assets/Services/Software Engineering/software-engineering-ai-projects-technoogy-stack-image.png" alt="Software Engineering Technology Stack" />
         </div>
       </div>

       <div className="software_tech_stack mobile-software-tech-stack">
         <div className="tech-stack-icon">
           <img src="/Assets/Services/Software Engineering/technology-stack-icon.svg" alt="Technology Stack Icon" />
         </div>
         <div className="tech-stack-title">
           <h2>Technology Stack</h2>
         </div>
         <div className="tech-stack-image">
           <img src="/Assets/Responsive Mobile/technologgy-stack-image.png" alt="Software Engineering Technology Stack" />
         </div>
       </div>
     </div>
   );
};

export default SoftwareEngineering; 